import { render, staticRenderFns } from "./FileComment.vue?vue&type=template&id=52da0b63"
import script from "./FileComment.vue?vue&type=script&lang=ts"
export * from "./FileComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports